export default __webpack_public_path__ + "static/media/motorcycle.a994cbf9.svg";